
export default {
  data() {
    return {
      alert: false,
      form : {
        id : '',
        type : '',
        borang : '',
      },
      dax : 'INI DARI QUERY',

      ambil : 'coba katanya',



      list_data : [],
      page_limit : 8,
      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      mdl_lihat : false,
      btn_add: false,

    }
  },
  methods: {
    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.office_borang_acu + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },
    addData : function(number) {

        // this.form.borang = document.getElementById("editor").value;

        var myEditor = document.querySelector('#editor')
        this.form.borang = myEditor.children[0].innerHTML

        fetch(this.$store.state.url.office_borang_acu + "addData", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

    },

    editData : function(){


        var myEditor = document.querySelector('#editor')
        this.form.borang = myEditor.children[0].innerHTML

          console.log(this.form.borang)

      fetch(this.$store.state.url.office_borang_acu + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },


    removeData : function(data){
      fetch(this.$store.state.url.office_borang_acu + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            id : data.id
          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },


    selectData(data){
      this.form.id = data.id;
      this.form.type = data.type;
      this.form.borang = data.borang;

      // document.getElementById("editor").value = 'zzzzz';

      setTimeout(() => {
        var myEditor = document.querySelector('#editor')
        myEditor.children[0].innerHTML = data.borang

        console.log( data.borang)
      }, 60);

    },







    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },




    // ====================================== PAGINATE ====================================

   
  },
  mounted () {
    this.getView();
  },
}
